var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36453 0 0 3.36453 0 7.5C0 11.6355 3.36453 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.36453 11.6355 0 7.5 0ZM4.30178 9.97574L6.53116 7.66217C6.62312 7.56658 6.62312 7.41529 6.53116 7.3197L4.31913 5.02478L5.20275 4.17355L7.36996 6.42235C7.41659 6.47054 7.48057 6.498 7.54767 6.498C7.61476 6.498 7.67874 6.4708 7.72537 6.42261L9.8931 4.17381L10.7762 5.02504L8.56469 7.31996C8.47273 7.41555 8.47273 7.56684 8.56469 7.66242L10.7941 9.976L9.91097 10.827L7.72537 8.55951C7.67874 8.51133 7.61476 8.48413 7.54767 8.48413C7.48057 8.48413 7.41659 8.51133 7.36996 8.55977L5.18513 10.827L4.30178 9.976V9.97574Z",
    fill: "#E67072"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleClose);
export default __webpack_public_path__ + "static/media/icon-circle-close.e23913745c769c847dc1281050a00463.svg";
export { ForwardRef as ReactComponent };